import { render, staticRenderFns } from "./dialogEditHouse.vue?vue&type=template&id=23f5c52f&scoped=true"
import script from "./dialogEditHouse.vue?vue&type=script&lang=js"
export * from "./dialogEditHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5c52f",
  null
  
)

export default component.exports